<script setup lang="ts">
import { ref } from 'vue'
import { useVehicleStore } from '../../stores/vehicleStore'
import { usePartsStore } from '../../stores/partsStore'
import { useSearchHistoryStore } from '../../stores/searchHistoryStore'

const vehicleStore = useVehicleStore()
const partsStore = usePartsStore()
const historyStore = useSearchHistoryStore()
const oemInput = ref('')
const isSearching = ref(false)

async function search() {
  const val = oemInput.value.trim()
  if (val.length < 3) return

  isSearching.value = true
  vehicleStore.oemNumber = val

  try {
    await partsStore.loadOemParts(val)
    const count = partsStore.articles.length
    historyStore.addEntry({
      type: 'oem',
      query: val,
      carName: `${count} deler funnet`,
      carId: null,
    })
  } finally {
    isSearching.value = false
  }
}
</script>

<template>
  <form class="oem-search" @submit.prevent="search">
    <h3>Finn del på OE-Nummer</h3>
    <div class="oem-search__row">
      <input
        v-model="oemInput"
        type="text"
        placeholder="OE-nummer..."
        class="oem-search__input"
        :disabled="isSearching"
      />
      <button
        type="submit"
        class="oem-search__btn"
        :disabled="isSearching || oemInput.trim().length < 3"
      >
        <span v-if="isSearching" class="spinner"></span>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
        </svg>
      </button>
    </div>
  </form>
</template>

<style scoped lang="scss">
.oem-search {
  max-width: 400px;
  margin: 0 auto;

  h3 { margin-bottom: 0.75rem; }

  &__row {
    display: flex;
    border: 2px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
  }

  &__input {
    flex: 1;
    border: none;
    padding: 12px;
    font-size: 1rem;
    outline: none;
    min-width: 0;

    &:focus {
      box-shadow: inset 0 0 0 1px #002868;
    }
  }

  &__btn {
    background: #002868;
    color: white;
    border: none;
    padding: 0 16px;
    cursor: pointer;
    display: flex;
    align-items: center;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
